"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListItemTag = void 0;
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var styles_1 = require("@mui/material/styles");
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var base_1 = require("@mui/base");
var ListItemTagClasses_1 = __importStar(require("./ListItemTagClasses"));
var css_1 = require("@emotion/css");
var useUtilityClasses = function (ownerState) {
    var classes = ownerState.classes;
    var slots = {
        root: ['root'],
        noVariant: ['noVariant'],
    };
    return (0, base_1.unstable_composeClasses)(slots, ListItemTagClasses_1.getListItemTagUtilityClass, classes);
};
// This `styled()` function invokes @noflip. `styled-components` only supports @noflip in string templates.
// Do not convert these styles to a JS object as it will break.
// @noflip is used to stop certain styles from flipping when the language direction is toggled.
var Root = (0, styles_1.styled)(Typography_1.default, {
    shouldForwardProp: function (prop) { return prop !== 'fontColor'; },
})(function (_a) {
    var backgroundColor = _a.backgroundColor, fontColor = _a.fontColor, onClick = _a.onClick, theme = _a.theme;
    return "\n        border-radius: 0.125rem;\n        padding: 0;\n        /* @noflip */\n        padding-left: 0.25rem;\n        /* @noflip */\n        padding-right: calc(0.25rem - 1px); // to account for extra pixel from letter-spacing\n        overflow: hidden;\n        display: inline-block;\n        cursor: ".concat(onClick ? 'pointer' : 'inherit', ";\n        background-color:\n            ").concat(backgroundColor ||
        (theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main), ";\n        color:\n            ").concat(fontColor ||
        theme.palette.getContrastText(backgroundColor ||
            (theme.palette.mode === 'dark' ? theme.palette.primary.dark : theme.palette.primary.main)), ";\n        &.").concat(ListItemTagClasses_1.default.noVariant, " {\n            font-weight: 700; // bold\n            letter-spacing: 1px;\n            font-size: 0.625rem;\n            line-height: 1rem;\n            height: 1rem;\n        },");
});
var ListItemTagRender = function (props, ref) {
    var _a;
    var userClasses = props.classes, label = props.label, variant = props.variant, userClassName = props.className, otherTypographyProps = __rest(props, ["classes", "label", "variant", "className"]);
    var defaultClasses = useUtilityClasses(props);
    var rootUserClass = userClasses.root, otherUserClasses = __rest(userClasses, ["root"]);
    return (react_1.default.createElement(Root, __assign({ ref: ref, variant: variant || 'overline', className: (0, css_1.cx)(defaultClasses.root, (_a = {}, _a[defaultClasses.noVariant] = !variant, _a), userClassName), classes: __assign({ root: rootUserClass }, otherUserClasses), "data-testid": 'blui-list-item-tag' }, otherTypographyProps), label));
};
/**
 * [ListItemTag](https://brightlayer-ui-components.github.io/react/components/list-item-tag) component
 *
 * `<ListItemTag>` is a text item with a colored background and rounded corners that is used to tag lists.
 */
exports.ListItemTag = react_1.default.forwardRef(ListItemTagRender);
exports.ListItemTag.propTypes = {
    label: prop_types_1.default.string.isRequired,
    backgroundColor: prop_types_1.default.string,
    fontColor: prop_types_1.default.string,
    classes: prop_types_1.default.shape({
        root: prop_types_1.default.string,
    }),
};
exports.ListItemTag.defaultProps = {
    noWrap: true,
    display: 'inline',
    classes: {},
};
exports.ListItemTag.displayName = 'ListItemTag';
